module.exports = __webpack_public_path__ + "static/media/bg-notfound-tablet.1e19304a.jpg";